import { AdImage } from '@/components/AdItem/AdImage';
import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { useAccount } from '@/resource/account';
import { AdItemType, canAccessAd, isApprovedAd } from '@/resource/ad';
import { cx } from '@/util/cx';
import { formatExpires, formatOfflineDate } from '@/util/date';
import { Fragment } from 'react';
import styles from './AdSummaryItem.module.scss';

type Props = {
  item: AdItemType;
  filterCategoryIds?: number[];
  theme?: 0 | 1 | 2 | 3 | 4 | 5;
};

export function AdSummaryItem({ item, theme }: Props) {
  const { profile } = useAccount();
  const canAccess = canAccessAd(profile, item);
  const { expires, offline_date, is_offline } = item;
  const categories = item.categories.data;
  const location = item.location.data;
  const overviewType =
    item.type === 'offer' ? 'market_offers' : 'market_requests';

  return (
    <div
      className={cx(
        styles.Item,
        theme != null && styles[`theme-${[theme]}`],
        !canAccess && styles.inaccessible
      )}
    >
      <AdImage item={item} to={{ type: 'ad_detail', ad: item }} />

      <div className={styles.ItemBody}>
        {expires && offline_date && !is_offline && isApprovedAd(item) && (
          <div>
            <Icon theme={1} icon="clock" />

            {expires.y === 0 && expires.m === 0 && expires.d === 0
              ? `Nog ${formatExpires(expires)}`
              : `Online tot ${formatOfflineDate(offline_date)}`}
          </div>
        )}

        <div>
          <Icon theme={1} icon="folder" />
          <div>
            {categories.map((category, i) => (
              <Fragment key={category.id}>
                <Link
                  to={{
                    type: overviewType,
                    filter: {
                      category_ids: [category.id],
                    },
                  }}
                >
                  {category.name}
                </Link>
                {i < categories.length - 1 && ', '}
              </Fragment>
            ))}
          </div>
        </div>
        <div>
          <Icon theme={1} icon="location" />
          <Link
            to={{
              type: overviewType,
              filter: {
                distance: 15,
                postal_code: location.postal_code,
                sort: 'adjacent',
              },
            }}
          >
            {location.place}
          </Link>
        </div>
      </div>
    </div>
  );
}
